import {
  DEFAULT_LIMIT,
  fetchAllCursorPages,
  schedulingDelete,
  schedulingGet,
  schedulingPost,
  schedulingPut,
  versionBody,
} from "./client";

export function listSchedules({
  organizationRef,
  scope,
  excludedOrganizationRefs,
  scheduleId,
  practitionerRef,
  serviceCategoryId,
  startsAt,
  endsAt,
  status,
  cursor,
  limit = DEFAULT_LIMIT,
  signal,
  consistency,
}) {
  return schedulingGet("schedule", {
    organizationRef,
    scope,
    excludedOrganizationRefs,
    scheduleId,
    practitionerRef,
    serviceCategoryId,
    startsAt,
    endsAt,
    status,
    cursor,
    limit,
  }, { signal, consistency });
}

export function getSchedule({ organizationRef, scheduleId }) {
  return schedulingGet("schedule", { organizationRef, scheduleId }, { consistency: "strong" });
}

export async function listAllSchedules(params) {
  return fetchAllCursorPages({
    signal: params.signal,
    itemsKey: "schedules",
    fetchPage: (cursor) => listSchedules({ ...params, cursor }),
  });
}

export function createSchedule(body) {
  return schedulingPost("schedule", body);
}

export function updateSchedule(body) {
  const { expectedVersion, ...rest } = body;
  return schedulingPut("schedule", {
    ...rest,
    ...versionBody(expectedVersion),
  });
}

export function cancelSchedule({ organizationRef, scheduleId, expectedVersion }) {
  return schedulingDelete("schedule", {
    organizationRef,
    scheduleId,
    ...versionBody(expectedVersion),
  });
}
